import React from 'react';
import Card from '../../Common/Card/Card';

type Props = {
	mode?: string;
	children: JSX.Element | JSX.Element[];
};
const Username: React.FunctionComponent<Props> = ({ mode, children }) => {
	return (
		<Card mode={mode} label="User name">
			<div style={{ marginRight: '30px' }}>{children}</div>
		</Card>
	);
};

export default Username;
